import { screen } from '@ebh/capsule/theme';
import { THEME_COLORS } from '../utils/theme/colors';

export default {
  ssoHeader: [
    {
      backgroundColor: THEME_COLORS['primary-400'],
      alignItems: 'center' as const,
      padding: 8,
      display: 'flex',
      gap: 5,
      cursor: 'pointer',
    },
    screen('md', { display: 'none' }),
  ],
  ssoHeaderIcon: {
    color: THEME_COLORS.white,
  },
};
